import { render } from "./InformationLayout.vue?vue&type=template&id=7ecce930&scoped=true"
import script from "./InformationLayout.vue?vue&type=script&lang=js"
export * from "./InformationLayout.vue?vue&type=script&lang=js"

import "./InformationLayout.vue?vue&type=style&index=0&id=7ecce930&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ecce930"]])

export default __exports__